import React, { useState } from "react";
import TopBar from "../../components/admin/TopBar";
import DataTable from "react-data-table-component";
import { ucwords } from "../../utils/Ucwords";
import { DateFormatter } from "../../utils/DateFormatter";
import useFetch from "../../hooks/useFetch";

const AdminDashboardPage = () => {
  const API_URL = process.env.REACT_APP_API_URL;
  const [searchTerm, setSearchTerm] = useState("");
  const { data } = useFetch(`${API_URL}/consultation`);

  const filteredClients = (data || []).filter((clients) => {
    return (
      `${ucwords(clients.firstname)} ${ucwords(clients.lastname)}`
        .toLowerCase()
        .includes(searchTerm.toLowerCase()) ||
      clients.email.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  const columns = [
    {
      name: "Full Name",
      selector: (row) => `${ucwords(row.firstname)} ${ucwords(row.lastname)}`,
      sortable: true,
    },
    {
      name: "Email Address",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: "Inquiries",
      selector: (row) => row.service,
      sortable: true,
    },
    {
      name: "Date & Time",
      selector: (row) => `${DateFormatter(row.created_at)}`,
      sortable: true,
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        fontWeight: "bold",
        fontSize: "14px",
      },
    },
  };

  return (
    <>
      <TopBar />
      <div className="p-2 mt-16">
        <div className="flex flex-col">
          <div className="flex pb-2 border-b-2">
            <div className="font-semibold text-xl">
              <label htmlFor="">List of Inquiries</label>
            </div>
          </div>
          <div className="mt-5">
            <div className="flex justify-end gap-3">
              <label htmlFor="search" className="mt-1.5">
                Search:
              </label>
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="form-input p-1.5 block border-gray-300 rounded-lg shadow-sm focus:ring-green-800 focus:border-green-800 mb-1"
              />
            </div>
            <div className="relative overflow-x-auto">
              <DataTable
                columns={columns}
                data={filteredClients}
                pagination
                responsive
                highlightOnHover
                pointerOnHover
                paginationPerPage={10}
                paginationRowsPerPageOptions={[5, 10, 15, 20]}
                customStyles={customStyles}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminDashboardPage;
